import React from 'react';
import { useLanguage } from '../LanguageContext';
import { CONTENT } from '../content';
import WhyJoin from '../components/WhyJoin';
import TestimonialCarousel from '../components/TestimonialCarousel';

export default function Physicians() {
  const { language } = useLanguage();
  const t = CONTENT[language];
  const p = t.physicians;

  // Filter for physician testimonials only
  const physicianTestimonials = t.testimonials.filter(item => item.type === 'PCP');

  return (
    <div className="flex flex-col">
       <div className="bg-white py-20">
         <div className="container mx-auto px-4 lg:px-12">
            <h1 className="text-4xl font-bold text-suncoast-dark mb-6 text-center">{p.title}</h1>
            <p className="text-xl text-gray-600 text-center max-w-3xl mx-auto mb-16">
              {p.subtitle}
            </p>

            <div className="grid md:grid-cols-2 gap-8 mb-20">
              <div className="bg-suncoast-offWhite p-8 rounded-xl border-t-4 border-suncoast-secondary">
                <h2 className="text-2xl font-bold text-suncoast-dark mb-4">{p.pcpTitle}</h2>
                <ul className="space-y-4">
                  {p.pcpPoints.map((point, index) => (
                    <li key={index} className="flex items-start gap-2">
                      <span className="text-green-500 font-bold">✓</span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="bg-suncoast-offWhite p-8 rounded-xl border-t-4 border-suncoast-primary">
                <h2 className="text-2xl font-bold text-suncoast-dark mb-4">{p.adminTitle}</h2>
                <ul className="space-y-4">
                  {p.adminPoints.map((point, index) => (
                    <li key={index} className="flex items-start gap-2">
                      <span className="text-green-500 font-bold">✓</span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Dedicated Physician Testimonials Section */}
            <div className="mb-20">
               <div className="text-center mb-10">
                 <h2 className="text-3xl font-bold text-suncoast-dark">
                   {p.voicesSection.title}
                 </h2>
                 <p className="text-gray-600 mt-2">
                   {p.voicesSection.subtitle}
                 </p>
               </div>
               <TestimonialCarousel testimonials={physicianTestimonials} />
            </div>

            <div className="mb-20">
               <WhyJoin />
            </div>
         </div>
       </div>
    </div>
  );
}